export const news = [
  {
    date: "now",
    title: "Now You Hear It",
    description: "Debut EP exploring themes of physical and mental realities"
  },
  {
    date: "march 2025", 
    title: "Lyspunkt Prize",
    description: "Awarded for lyrical work in 2024"
  },
  {
    date: "spring 2026",
    title: "Debut album - coming",
    description: "First full-length project in development"
  }
]; 